module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/header-pop-d5421d90b8795bdcedd28e586f4ce4ee.png";